var React = require('react');

function IconCloseLg (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"currentColor","fill":"none"},[React.createElement("path",{"d":"M0.5,0.5 L19.5,19.5","key":0}),React.createElement("path",{"d":"M0.5,19.5 L19.5,0.5","key":1})]));
}

IconCloseLg.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = IconCloseLg;

IconCloseLg.default = IconCloseLg;
